module.exports = __webpack_public_path__ + "static/logo-1a08f63ef0dc7ce47bef9f1a10cdd40c.png";